import { render, staticRenderFns } from "./FcJobPost.vue?vue&type=template&id=16d0bcbe&scoped=true&"
import script from "./FcJobPost.vue?vue&type=script&lang=js&"
export * from "./FcJobPost.vue?vue&type=script&lang=js&"
import style0 from "./FcJobPost.vue?vue&type=style&index=0&id=16d0bcbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d0bcbe",
  null
  
)

export default component.exports